import { PackingMaterialsLineItemT, PackingMaterialsValueObj } from "../../types/PackingMaterialsT"

const PackingMaterialsList = [
    {
        item: 'dish_pack',
        label: 'Dish Pack',
        rate: '',
    },
    {
        item: 'cartons_1_5',
        label: 'Cartons - 1.5 cubic ft.',
        rate: '',
    },
    {
        item: 'cartons_3_0',
        label: 'Cartons - 3.0 cubic ft.',
        rate: '',
    },
    {
        item: 'cartons_4_5',
        label: 'Cartons - 4.5 cubic ft.',
        rate: '',
    },
    {
        item: 'mirror_pack',
        label: 'Mirror Pack',
        rate: '',
    },
    {
        item: 'wardrobe_cartons',
        label: 'Wardrobe Cartons',
        rate: '',
    },
    {
        item: 'mattress_bag_king',
        label: 'Mattress Bag - King',
        rate: '',
    },
    {
        item: 'mattress_bag_queen',
        label: 'Mattress Bag - Queen',
        rate: '',
    },
    {
        item: 'shrink_wrap',
        label: 'Shrink Wrap ',
        rate: '',
    },
    {
        item: 'bin_rental_each',
        label: 'Bin Rental - Each',
        rate: '',
    },
    {
        item: 'paper_pads',
        label: 'Paper Pads - 2-ply',
        rate: '',
    },
    {
        item: 'lamp_boxes',
        label: 'Lamp Boxes',
        rate: '',
    },
    {
        item: 'picture_boxes',
        label: 'Picture Boxes',
        rate: '',
    },
    {
        item: 'tape_rolls',
        label: 'Tape Rolls',
        rate: '',
    },
    {
        item: 'newsprint',
        label: 'Newsprint - Per Ream',
        rate: '',
    },
    {
        item: 'oversize_box',
        label: 'Oversize Box / TV',
        rate: '',
    },
    {
        item: 'grandfather_clock_piano',
        label: 'Grandfather Clock / Piano',
        rate: '',
    },
    {
        item: 'spec_crating_pallets',
        label: 'Spec. Crating / Pallets',
        rate: '',
    },
    {
        item: 'packing_time',
        label: 'Packing Time',
        rate: '',
    }
]



export const getDefaultPackingMaterials = (): Array<PackingMaterialsLineItemT> => {
    return PackingMaterialsList.map((item, index) => {
        let newObj = {
            ...PackingMaterialsValueObj,
            ...{
                item: item.item,
                label: item.label,
            }
        }
        return Object.assign({}, newObj)
    })
}

export default PackingMaterialsList